export var BackgroundVariant;
(function (BackgroundVariant) {
    BackgroundVariant["CHEVRON"] = "chevron";
    BackgroundVariant["SLOPESM"] = "slopeSm";
    BackgroundVariant["SLOPEMD"] = "slopeMd";
    BackgroundVariant["HEADING"] = "heading";
})(BackgroundVariant || (BackgroundVariant = {}));
export var BackgroundColorTheme;
(function (BackgroundColorTheme) {
    BackgroundColorTheme["GREEN"] = "green";
    BackgroundColorTheme["CORAIL"] = "corail";
    BackgroundColorTheme["BO"] = "backOffice";
})(BackgroundColorTheme || (BackgroundColorTheme = {}));
//# sourceMappingURL=Background.types.js.map